import { deepDiff } from '@/helpers/deepDiff'

export function hasDiff(
  after: Record<string, any>,
  before: Record<string, any>
) {
  return Object.keys(deepDiff(after, before)).length > 0
}
